import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        Organisation: null,
        // local address
        LocalAddress: null,
        LocalProvince: null,
        LocalCity: null,
        LocalDirectNumber: null,
        LocalMobile: null,
        LocalEmail: null,
        LocalWebsite: null,
        // Bangkok address
        BangkokSameAsAbove: null,
        BangkokNone: null,
        BangkokAddress: null,
        BangkokDirectNumber: null,
        BangkokMobile: null,
        //  Authorised by
        AuthorisedName: null,
        AuthorisedTitle: null,
        AuthorisedDirectNumber: null,
        AuthorisedMobile: null,
        AuthorisedEmail: null,
        // Contact Person
        ContactPersonName: null,
        ContactPersonTitle: null,
        ContactPersonDirectNumber: null,
        ContactPersonMobile: null,
        ContactPersonEmail: null,
        // 
        DescriptionOfServices: null,
        ExperienceInMICEIndustry: null,
        MembershipOfOtherAssociation: null,
        // files
        LORF2TMDocuments: null,
        COBRDocuments: null,
        COBLDocuments: null,
        COPPDocuments: null,
        AuthorisedSignature: null,
        // Category
        MembershipCategory: null,
        SubscriptionRateTHB: null,
        ForHotelOnlyNumberOfRooms: null,
        ForHotelOnlyCategory: null,
        ForHotelOnlyTotalBaht: null,
        // Authorised Signature
        CapitalLettersName: null,
        CapitalLettersTitle: null,
        CapitalLettersDate: null,
    },
    mutations: {
        setData(state, data) {
            state.Organisation = data.Organisation;
            state.OAMembership = data.OAMembership;
            //localaddress
            state.LocalAddress = data.LocalAddress;
            state.LocalProvince = data.LocalProvince;
            state.LocalCity = data.LocalCity;
            state.LocalDirectNumber = data.LocalDirectNumber;
            state.LocalMobile = data.LocalMobile;
            state.LocalEmail = data.LocalEmail;
            state.LocalWebsite = data.LocalWebsite;
            //Bangkokaddress
            state.BangkokSameAsAbove = data.BangkokSameAsAbove;
            state.BangkokNone = data.BangkokNone;
            state.BangkokAddress = data.BangkokAddress;
            state.BangkokDirectNumber = data.BangkokDirectNumber;
            state.BangkokMobile = data.BangkokMobile;
            //Authorisedby
            state.AuthorisedName = data.AuthorisedName;
            state.AuthorisedTitle = data.AuthorisedTitle;
            state.AuthorisedDirectNumber = data.AuthorisedDirectNumber;
            state.AuthorisedMobile = data.AuthorisedMobile;
            state.AuthorisedEmail = data.AuthorisedEmail;
            //ContactPerson
            state.ContactPersonName = data.ContactPersonName;
            state.ContactPersonTitle = data.ContactPersonTitle;
            state.ContactPersonDirectNumber = data.ContactPersonDirectNumber;
            state.ContactPersonMobile = data.ContactPersonMobile;
            state.ContactPersonEmail = data.ContactPersonEmail;
            //
            state.DescriptionOfServices = data.DescriptionOfServices;
            state.ExperienceInMICEIndustry = data.ExperienceInMICEIndustry;
            state.MembershipOfOtherAssociation = data.MembershipOfOtherAssociation;
            //files
            state.LORF2TMDocuments = data.LORF2TMDocuments;
            state.COBRDocuments = data.COBRDocuments;
            state.COBLDocuments = data.COBLDocuments;
            state.COPPDocuments = data.COPPDocuments;
            state.AuthorisedSignature = data.AuthorisedSignature;
            //Category
            state.MembershipCategory = data.MembershipCategory;
            state.SubscriptionRateTHB = data.SubscriptionRateTHB;
            state.ForHotelOnlyNumberOfRooms = data.ForHotelOnlyNumberOfRooms;
            state.ForHotelOnlyCategory = data.ForHotelOnlyCategory;
            state.ForHotelOnlyTotalBaht = data.ForHotelOnlyTotalBaht;
            //AuthorisedSignature
            state.CapitalLettersName = data.CapitalLettersName;
            state.CapitalLettersTitle = data.CapitalLettersTitle;
            state.CapitalLettersDate = data.CapitalLettersDate;
        },
    },
    getters: {
        OAMembership: state => state.OAMembership,
        dataAll: state => state,
    },
    actions: {

    }
})